module.exports = __webpack_public_path__ + "static/team-desk-54743f35b22d3a791798ce35dcfae972.png";